module.exports = __webpack_public_path__ + "img/tab_analytics-w.2e9083e0.svg";